
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import VisitorsCustomersReferenceManyToMany from '../Security/Acl/VisitorsCustomersReferenceManyToMany';
import UserCustomersReferenceManyToMany from '../Security/Acl/UserCustomersReferenceManyToMany';


export interface IGroupsCustomersAttributes extends IModelAttributes {
	groupsId: string;
	customersId: string;

	groups: Models.GroupEntity | Models.IGroupEntityAttributes;
	customers: Models.CustomerEntity | Models.ICustomerEntityAttributes;

}

@entity('GroupsCustomers')
export default class GroupsCustomers
	extends Model
	implements IGroupsCustomersAttributes {
	public static acls: IAcl[] = [
		new VisitorsCustomersReferenceManyToMany(),
		new UserCustomersReferenceManyToMany(),

	];

	@observable
	@attribute()
	public groupsId: string;

	@observable
	@attribute()
	public customersId: string;

	@observable
	@attribute({ isReference: true })
	public groups: Models.GroupEntity;

	@observable
	@attribute({ isReference: true })
	public customers: Models.CustomerEntity;


	constructor(attributes?: Partial<IGroupsCustomersAttributes>) {

		super(attributes);

		if (attributes) {
			if (attributes.groupsId) {
				this.groupsId = attributes.groupsId;
			}
			if (attributes.customersId) {
				this.customersId = attributes.customersId;
			}

			if (attributes.groups) {
				if (attributes.groups instanceof Models.GroupEntity) {
					this.groups = attributes.groups;
					this.groupsId = attributes.groups.id;
				} else {
					this.groups = new Models.GroupEntity(attributes.groups);
					this.groupsId = this.groups.id;
				}
			} else if (attributes.groupsId !== undefined) {
				this.groupsId = attributes.groupsId;
			}

			if (attributes.customers) {
				if (attributes.customers instanceof Models.CustomerEntity) {
					this.customers = attributes.customers;
					this.customersId = attributes.customers.id;
				} else {
					this.customers = new Models.CustomerEntity(attributes.customers);
					this.customersId = this.customers.id;
				}
			} else if (attributes.customersId !== undefined) {
				this.customersId = attributes.customersId;
			}
		}

	}


}
